import React from 'react';
import { Button } from 'antd';
import trans from '../../translations.json';
import './buttonGroup.scss';
export const ButtonGroup = (props) => {
  const buttonItems = Object.values(props.viewModes);

  return (
    <div className="ontario-margin-bottom-12-! covid-viz-buttonGroup">
      {buttonItems.map((item, idx) => (
        <Button
          key={idx}
          disabled={item === props.selected}
          onClick={() => props.handleOnClick(item)}
          aria-label={
            item === 'table'
              ? trans.general.accessibleTable[props.lang]
              : item
          }
          aria-hidden={item === 'table' ? 'false' : 'true'}
        >
          {trans.viewModes[item][props.lang]}
        </Button>
      ))}
    </div>
  );
};
